import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ThankYou = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  
  return (
    <div className="thank">
      <h2>شكراً لك يا {user.name.split(' ')[0]}, تم عمل الطلب بنجاح</h2>
      <p>نحن نقوم بالعمل على تنفيذ طلبك. سنقوم بإخبارك أولا بأول عن حالة طلبك عن طريق رسائل البريد الإلكترونى.</p>
      <p>أو تستطيع التحقق من حالة طلبك من خلال صفحة طلباتك.</p>

      <button 
        onClick={() => navigate("/orders")}
        className="buttonNoBorder"
      >
        صفحة طلباتك
      </button>

      <p style={{textAlign: "center"}}>أو</p>

      <button 
        onClick={() => navigate("/products")}
        className="buttonNoBorder"
      >
        استمر فى التسوق
      </button>
    </div>
  );
};

export default ThankYou;
